import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appSetBorderColor]'
})
export class SetBorderColorDirective {
  @Input('appSetBorderColor') borderColor: string;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    if(this.borderColor)
      this.el.nativeElement.style.borderColor = this.borderColor;
  }
}
